import './chunk-17755bd7.js';
import './chunk-8716473c.js';
import './chunk-5160dcda.js';
import './chunk-1a6eab4a.js';
import './chunk-dc90942e.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { I as Input } from './chunk-044817e6.js';
export { I as Input } from './chunk-044817e6.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Input);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/input.js
// module id = 234
// module chunks = 0